<template>
    <div class="action-wrapper">
        <slot name="prepend" />
        <slot>
            <div class="searchbar mb-2" v-if="false">
                <v-text-field
                    class="v-input-field--search"
                    outlined
                    clearable
                    dense
                    placeholder="SEARCH"
                    v-model="search"
                    @keyup.enter="sendFilters"
                    @click:clear="clearText"
                />
                <v-btn dense class="button" @click="sendFilters">
                    <v-icon small>mdi-magnify</v-icon>
                </v-btn>
            </div>

            <div class="mx-md-5 mx-lg-5 mx-sm-2 mx-0 mb-2 control-panel-actions">
                <v-menu :close-on-content-click="false" :offset-y="true">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn class="v-btn--filter" v-bind="attrs" v-on="on">
                            <div>
                                {{ $t('app.filter') }}
                                <v-avatar size="18" class="filter-num">{{ selectedFilters.length }}</v-avatar>
                            </div>
                            <v-icon>mdi-filter</v-icon>
                        </v-btn>
                    </template>

                    <v-list class="filter-list" dense elevation="0" expand>
                        <v-subheader><b>{{ $t('app.filters') }}</b></v-subheader>
                        <v-list-group v-for="(filter, i) in availableFilters" :key="i">
                            <template v-slot:activator>
                                <v-list-item-content>
                                    <v-list-item-title dense>{{ filter.title }}</v-list-item-title>
                                </v-list-item-content>
                            </template>
                            <v-list-item
                                class="filter"
                                dense
                                v-for="(item, i) in filter.items"
                                :key="i"
                            >
                                <v-list-item-content>
                                    <v-checkbox
                                        class="input-checkbox"
                                        multiple
                                        hide-details
                                        dense
                                        :label="item.title"
                                        v-model="filters[filter.key]"
                                        :value="item.id"
                                    />
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider/>
                        </v-list-group>
                        <div class="btn-container">
                            <v-btn
                                class="v-btn--primary v-btn--filter-actions small-body"
                                @click="sendFilters"
                            >
                                {{ $t('app.apply') }}
                            </v-btn>
                            <v-btn
                                class="v-btn--secondary v-btn--filter-actions small-body"
                                @click="clearFilters"
                            >
                                {{ $t('app.clear') }}
                            </v-btn>
                        </div>
                    </v-list>
                </v-menu>
            </div>
        </slot>
        <slot name="append" />
    </div>
</template>

<script>
import {EventBus} from "@/event-bus";
import {mapState} from "pinia/dist/pinia";
import {IndicatorsStore} from "../../../Store/Indicators/IndicatorsStore";
import _ from "lodash";

export default {
    name: "IndicatorsFilters",

    data() {
        return {
            search: null,
            filters: {
                academic_periods: [],
                statuses: [],
            },
        }
    },

    methods: {
        sendFilters() {
            let data = Object.assign({}, this.filters, {
                text: this.search
            });

            this.$emit('filter-reports', data);

            EventBus.$emit('reports.management.filter-reports', _.cloneDeep(data));
        },

        clearFilters() {
            this.filters = {
                academic_periods: [],
                statuses: [],
            };
            this.sendFilters();
        },

        clearText() {
            this.search = '';
            this.sendFilters();
        }
    },

    computed: {
        availableFilters() {
            const academicPeriodFilters = {
                title: 'Academic Period',
                key: 'academic_periods',
                items: this.academicPeriods
            };

            const statuses = {
                title: 'Statuses',
                key: 'statuses',
                items: this.statuses
            };

            return [academicPeriodFilters, statuses];
        },

        selectedFilters() {
            return [
                ...(this.filters.academic_periods || []),
                ...(this.filters.statuses || []),
            ];
        },

        ...mapState(IndicatorsStore, [
            'academicPeriods',
            'statuses'
        ]),
    },
}
</script>

<style scoped>

</style>
